import { Pipe, PipeTransform } from '@angular/core';
import { EmptyCheckOutStatus } from '@services';

@Pipe({
    name: 'emptyCheckOutStatus',
    standalone: true,
})
export class EmptyCheckOutStatusPipe implements PipeTransform {
    transform(value: EmptyCheckOutStatus | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case EmptyCheckOutStatus.ReadyForCheckout: return 'Ready For Checkout';
            case EmptyCheckOutStatus.CheckedOut: return 'Checked Out';
            case EmptyCheckOutStatus.ReadyForCheckoutEmpty: return 'Ready For Checkout - Empty';
            case EmptyCheckOutStatus.CheckedOutEmpty: return 'Checked Out - Empty';
            case EmptyCheckOutStatus.ReadyForCheckoutLoaded: return 'Ready For Checkout - Loaded';
            case EmptyCheckOutStatus.CheckedOutLoaded: return 'Checked Out - Loaded';
            case EmptyCheckOutStatus.Investigation: return 'Investigation';
            case EmptyCheckOutStatus.ShuntMovePending: return 'Shunt Move Pending';
            default:
                return value;
        }
    }
}
